export type InlineVideoPlatform = 'vimeo' | 'default-player'
export enum InlineVideoPlatforms {
  VIMEO = 'vimeo',
  DEFAULT_PLAYER = 'default-player',
}
